<template>
  <div>
    <groupCalendar :href='href' v-if='wxCpType===1'></groupCalendar>
    <!-- 话术库 -->
    <!-- <staffPage :href='href' v-if='wxCpType===11'></staffPage> -->
    <!-- 内容库 -->
    <!-- <contentPage :href='href' v-if='wxCpType===4'></contentPage> -->
    <!-- 客户信息 -->
    <customerPage :href='href' v-if='wxCpType===3'></customerPage>
    <circleFriends :href='href' v-if='wxCpType===2'></circleFriends>
    <!--IM即时通讯时，才连接webSocket并且显示会话列表，显示别人分配给我会话列表页面-->
    <!--<web-socket v-if='wxCpType===410050'></web-socket>
    <session-list v-if='wxCpType===410050' />-->
    <!--登录成功后会自动重定向到会话页面-->
     <loginForm v-if='wxCpType===-1 || wxCpType===4 || wxCpType===11 || wxCpType===12 || wxCpType === 13'></loginForm>
    <!-- 聊天提醒 -->
    <!--  <chatRemind v-if='wxCpType===12'></chatRemind> -->
  </div>
</template>

<script>
import groupCalendar from '../groupCalendar/groupCalendar'
import staffPage from '../chatToolBar/staffPage'
import customerPage from '../chatToolBar/customerPage'
import chatRemind from '../chatToolBar/chatRemind'
import contentPage from '../chatToolBar/contentPage'
import circleFriends from '../circleFriends/circleFriends'
import sessionList from '../iM/sessionList'
import webSocket from '../iM/webSocket/index'
import loginForm from './loginForm'

export default {
  data () {
    return {
      href: {
        memberId: 0,
        tenancyId: 0,
        id: 0,
        corpId: '', //ww76b6c51c3935e90d
      },
      wxCpType: this.$store.state.auth.cpType, // -2 
      config: {},
    }
  },
  created () {
    // this.$store.dispatch('setCorpId', this.href.corpId)
  },
  mounted () {
    let isWl = false
    let href = window.location.search && window.location.search.split('?')[1]
    let data = href.split('&')
    data.map((item) => {
      let array = item.split('=')
      // wxCpType = 1 群日历详情
      // wxCpType = 11 企业微信话术库
      // wxCpType = 4 企业微信内容库
      // wxCpType = 3 企业微信个人资料
      //wxCpType = 410050 别人分配给我的会话列表
      console.log(array, 'array')
      if (array[0] === 'wxCpType') {
        this.wxCpType = Number(array[1])
        this.$store.dispatch('setCpType', this.wxCpType)
        console.log(this.$store.state.auth.cpType, 'wxCpType1111111');
      } else if (array[0] === 'memberId') {
        this.href.memberId = array[1]
        this.$store.dispatch('setMemberId', this.href.memberId)
        localStorage.setItem('memberId', this.href.memberId)
      } else if (array[0] === 'detailId') {
        this.href.id = array[1]
      } else if (array[0] === 'tenancyId') {
        this.href.tenancyId = array[1]
      } else if (array[0] === 'corpId') {
        this.href.corpId = array[1]
        this.$store.dispatch('setCorpId', this.href.corpId)
        localStorage.setItem('corpId', this.href.corpId)
        console.log(this.$store.state.auth.corpId, 'this.$store.state.auth.corpId')
      } else if (array[0] === 'code') {
        this.$store.dispatch('setCpCode', array[1])
        console.log(this.$store.state.auth.cpCode, 'this.$store.state.auth.cpCode')
      }

      if (array[1] === 'wuling') {
        isWl = true
      }
    })

    // this.wxCpType = Number(this.getQueryString('wxCpType'))
    if (isWl) {
      this.wxCpType = -1
    }

    this.$store.dispatch('setCpType', this.wxCpType)
    console.log(this.$store.state.auth.cpType, 'wxCpType2222222222222222');
    console.log(this.wxCpType, 'this.wxCpType');
  },
  methods: {
  },
  components: {
    groupCalendar, customerPage, circleFriends, sessionList, webSocket, loginForm, chatRemind, staffPage, contentPage
  },
}
</script>
 
<style lang="less" scoped>
</style>
